import { BreadcrumbProps, BreadcrumbCrumbProps } from '@procore/core-react/dist/_typedoc/Breadcrumbs/Breadcrumbs.types.json';
import * as React from 'react';
export default {
  BreadcrumbProps,
  BreadcrumbCrumbProps,
  React
};